export const m = {
    music: '网易云音乐',
    findMusic: '发现音乐',
    myMusic: '我的音乐',
    friend: '朋友',
    musician: '音乐人',
    download: '下载客户端'
}


//////////////////
// WEBPACK FOOTER
// ./static/lang/en-US.js
// module id = /9NN
// module chunks = 82